// ============================
// Application Configuration
// ============================

const host = typeof window !== "undefined" ? window.location.hostname : "";
const isProdHost = host === "thelifestyleonline.com" || host === "www.thelifestyleonline.com";

const defaultWpBaseUrl = isProdHost
  ? "https://api.thelifestyleonline.com"
  : "https://betaapi.thelifestyleonline.com";

const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || `${defaultWpBaseUrl}`,
  WP_BASE_URL: process.env.REACT_APP_WP_BASE_URL || defaultWpBaseUrl,
};



export default config;